/** A failed request as a short reason in the interface language. */
import type { MessageKey } from '../i18n/messages.js';
import { ApiError } from '../lib/api-client.js';

type Tf = (k: MessageKey, vars: Record<string, string | number>) => string;

export function errorText(err: unknown, tf: Tf): string {
  if (err instanceof ApiError) {
    if (err.status === 429) {
      const s = Number(err.details?.retry_after_s ?? 60);
      return tf('error.rate_limited', { min: Math.max(1, Math.ceil(s / 60)) });
    }
    if (err.status === 502 || err.code === 'vendor_error') return tf('error.vendor', {});
    if (err.status === 403) return tf('error.forbidden', {});
  }
  return tf('error.generic', {});
}

export function apiCode(err: unknown): string | null {
  return err instanceof ApiError ? err.code : null;
}

export function apiStatus(err: unknown): number | null {
  return err instanceof ApiError ? err.status : null;
}

/** The object does not exist for this user: 404, or 422 for an id that is not one. */
export function notFound(err: unknown): boolean {
  return err instanceof ApiError && (err.status === 404 || err.status === 422);
}
